module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-maintenance-system/master-maintenance-system.component.scss
// module id = ./src/app/master/master-maintenance-system/master-maintenance-system.component.scss
// module chunks = main